import styled from 'styled-components';

export const StyledLoginHistory = styled.div`
    padding: 2rem;
`;
